import { useState, useEffect } from "react";
import axios from "axios"

import GridListaContratoLocacao from './components/Grid-contrato.js';
import GridListaObjetoCusto from './components/Grid-objeto-custo.js';
import GridListaCustoMes from './components/Grid-custo-mes.js';

import GlobalStyle from "../../../../styles/global-new.js";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";






const Div = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: column;

  border-radius: 15px;
`;

const Container = styled.div`
  width: 89.2vw;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;


`;

const DivBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  flex-direction: column;
  width: 100%;


`;

const DivAba = styled.div`
  background-color: #fff;
  display: flex;
  overflow: auto;
  flex-direction: column;
  width: 100%;
  box-shadow: 0px 0px 2px #eee;
`;




const TabsContainer = styled.div`


  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0px;
  gap: 10px;

  
`;






export const TabButton = styled.button`
  padding: 10px 20px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  background-color: ${(props) => (props.ativo ? '#fff' : '#E5F7EE')};
  color: ${(props) => (props.ativo ? '#008000' : '#008000')};
  border-radius: 6px;
  transition: all 0.3s ease;

  width: 250px;
  

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #076333;
  }

  @media (max-width: 768px) {
    flex: 0 0 48%; // 2 colunas com pequeno espaçamento
  }

  @media (max-width: 480px) {
    flex: 0 0 48%; // 1 coluna total em telas muito pequenas
  }
`;




function Usuarios({ urlApi }) {

  const token = localStorage.getItem('token');




  //------------------------------------------TIPO/SUBTIPO MATERIAL-----------------------------------------------------------------//

  const [listaContratoLocacao, setListaContratoLocacao] = useState([]);
  const [listaParcela, setListaParcela] = useState([]);
  const [listaTotalPorContrato, setListaTotalPorContrato] = useState([]);
  const [listaItensPorContrato, setListaItensPorContrato] = useState([]);

  const [listaObjetoCusto, setListaObjetoCusto] = useState([]);
  const [listaObjetoCustoMes, setListaObjetoCustoMes] = useState([]);
  const [listaObjetoCustoMesContrato, setListaObjetoCustoMesContrato] = useState([]);

  const [listaCustoMes, setListaCustoMes] = useState([]);
  const [listaCustoMesCusto, setListaCustoMesObjetoCusto] = useState([]);
  const [listaItemCustoMesCusto, setListaItemCustoMesObjetoCusto] = useState([]);



  const getDados = async () => {
    try {
      const res = await axios.get(`${urlApi}central-ti/lista-contrato`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaContratoLocacao(res.data);

      const res1 = await axios.get(`${urlApi}central-ti/lista-parcela`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaParcela(res1.data);

      const res2 = await axios.get(`${urlApi}central-ti/lista-total`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaTotalPorContrato(res2.data);

      const res3 = await axios.get(`${urlApi}central-ti/lista-itens-parcela`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaItensPorContrato(res3.data);

      const res4 = await axios.get(`${urlApi}central-ti/lista-objeto-custo`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaObjetoCusto(res4.data);

      const res5 = await axios.get(`${urlApi}central-ti/lista-objeto-custo-mes`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaObjetoCustoMes(res5.data);

      const res6 = await axios.get(`${urlApi}central-ti/lista-objeto-custo-mes-contrato`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaObjetoCustoMesContrato(res6.data);


      const res7 = await axios.get(`${urlApi}central-ti/lista-custo-mes`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaCustoMes(res7.data);

      const res8 = await axios.get(`${urlApi}central-ti/lista-custo-mes-objeto-custo`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaCustoMesObjetoCusto(res8.data);

      const res9 = await axios.get(`${urlApi}central-ti/lista-item-custo-mes-objeto-custo`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListaItemCustoMesObjetoCusto(res9.data);

    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };


  useEffect(() => {
    getDados();
  }, []);





  const [abaAtiva, setAbaAtiva] = useState("mes");




  return (
    <>


      <Div>
        <Container>


          <DivBody>
            <DivAba>
              <TabsContainer>
                <TabButton active={abaAtiva === "mes"} onClick={() => setAbaAtiva("mes")}>Mês</TabButton>
                <TabButton active={abaAtiva === "objetocusto"} onClick={() => setAbaAtiva("objetocusto")}>Objeto Custo</TabButton>
                <TabButton active={abaAtiva === "contrato"} onClick={() => setAbaAtiva("contrato")}>Contrato</TabButton>


              </TabsContainer>

              {abaAtiva === "mes" && <GridListaCustoMes
                listaCustoMes={listaCustoMes}
                listaCustoMesCusto={listaCustoMesCusto}
                listaItemCustoMesCusto={listaItemCustoMesCusto}
              />}

              {abaAtiva === "objetocusto" && <GridListaObjetoCusto
                listaObjetoCusto={listaObjetoCusto}
                listaObjetoCustoMes={listaObjetoCustoMes}
                listaObjetoCustoMesContrato={listaObjetoCustoMesContrato} />}


              {abaAtiva === "contrato" && <GridListaContratoLocacao
                listaContratoLocacao={listaContratoLocacao}
                listaParcela={listaParcela}
                listaTotalPorContrato={listaTotalPorContrato}
                listaItensPorContrato={listaItensPorContrato} />}




            </DivAba>






          </DivBody>
        </Container>

        <div>
          <ToastContainer
            autoClose={2500}
            position={toast.POSITION.BOTTOM_LEFT}
            style={{ width: '400px', fontSize: '22px' }}
          />

        </div>
      </Div>

      <GlobalStyle />
    </>
  );
}

export default Usuarios;
